import React, { useState, useEffect } from 'react';
import { translate } from '../Services/translation';

export const COOKIE_DECISION_STORAGE_KEY = 'cookie_decision';
const adStorage = "ad_storage";

const CookieBanner = () => {
    const [collapsed, setCollapsed] = useState();
    const [cookies, setCookies] = useState([
        {
            "allow": false,
            "key": adStorage,
            "name": "Markedsføring"
        },
        {
            "allow": false,
            "key": "personalization_storage",
            "name": "Personalisering"
        },
        /*{
            "allow": true,
            "key": "security_storage",
            "name": "Sikkerhet"
        },*/
        {
            "allow": false,
            "key": "analytics_storage",
            "name": "Analyse"
        }/*,
        {
            "allow": true,
            "key": "functionality_storage",
            "name": "Custom tracking"
        }*/
    ]);

    const getStoredCookies = () => {
        return JSON.parse(localStorage.getItem(COOKIE_DECISION_STORAGE_KEY)) || [];
    };

    const getConsents = () => {
        let consents = {};
        cookies.forEach(c => {
            consents[c.key] = c.allow ? 'granted' : 'denied';
            if (c.key == adStorage) {
                consents["ad_user_data"] = c.allow ? 'granted' : 'denied';
                consents["ad_personalization"] = c.allow ? 'granted' : 'denied';
            }
        });
        getStoredCookies().forEach(c => {
            consents[c.key] = c.allow ? 'granted' : 'denied';

            if (c.key == adStorage) {
                consents["ad_user_data"] = c.allow ? 'granted' : 'denied';
                consents["ad_personalization"] = c.allow ? 'granted' : 'denied';
            }
        });
        return consents;
    };

    const getDefaultConsents = () => {
        let consents = {};
        cookies.forEach(c => {
            if (c.key == adStorage) {
                consents["ad_user_data"] = 'denied';
                consents["ad_personalization"] = 'denied';
            }            
            consents[c.key] = 'denied';            
        });
        return consents;
    } 

    const saveCookies = (cookieList, acceptAll) => {
        let state = cookieList.map((c) => ({ key: c.key, allow: acceptAll ? true : c.allow }));
        localStorage.setItem(COOKIE_DECISION_STORAGE_KEY, JSON.stringify(state));

        // Update consent
        window.dataLayer = window.dataLayer || [];
        if (window.gtag == null) {
            window.gtag = function () { window.dataLayer.push(arguments); }
        }
        window.gtag('consent', 'update', getConsents());
        dataLayer.push({
            'event': 'cookie_consent_update'
        });
    };

    useEffect(() => {        
        window.dataLayer = window.dataLayer || [];
        if (window.gtag == null) {
            window.gtag = function () { window.dataLayer.push(arguments); }
        }

        let consents = getDefaultConsents();
        window.gtag('consent', 'default', consents);
        dataLayer.push({
            'event': 'default_consent'
        });

        if (getStoredCookies().length != 0) {
            setCollapsed(true);
            window.dataLayer = window.dataLayer || [];
            if (window.gtag == null) {
                window.gtag = function () { window.dataLayer.push(arguments); }
            }
            window.gtag('consent', 'update', getConsents());
            dataLayer.push({
                'event': 'cookie_consent_update'
            });
        } else {
            setCollapsed(false);
        }        

        let newCookies = [...cookies];
        for (const [consentKey, consentValue] of Object.entries(getConsents())) {
            let foundIndex = newCookies.findIndex(c => c.key == consentKey);
            if (foundIndex > -1) {
                newCookies[foundIndex].allow = (consentValue == 'granted');
            }
        };
        setCookies(newCookies);

    }, [setCollapsed, setCookies]);

    const acceptCookies = (acceptAll) => {
        saveCookies(cookies, acceptAll);
        setCollapsed(true);
    };

    const declineCookies = () => {
        const cookieList = cookies.map(cookie => {            
            return { ...cookie, allow: false};
        }); // Set all denied
        setCookies(cookieList);
        saveCookies(cookieList);
        setCollapsed(true);
    };

    const onCookieChange = (key, checked) => {
        let newCookies = [...cookies];
        const foundIndex = newCookies.findIndex(c => c.key == key);
        if (foundIndex > -1) {
            newCookies[foundIndex].allow = checked;
            setCookies(newCookies);
        }
    }

    return <div className={`cookie-banner ${collapsed ? 'collapsed' : ''}`}>
        <div className="cookie-banner__wrapper">
            <div className="row">
                <div className="columns small-12">
                    <div className="cookie-banner__banner">
                        <div className="cookie-banner__content">
                            <div className="cookie-banner__description">
                                {translate("coptikk.cookie.description")}
                            </div>
                            <div className="cookie-banner__categories">
                                {cookies.map(cookie =>
                                    <div className="cookie-wrapper" key={cookie.key}>
                                        <div className="switch tiny">
                                            <input className="switch-input" id={`s-${cookie.key}`} type="checkbox" checked={cookie.allow}
                                                onChange={(event) => onCookieChange(cookie.key, event.target.checked)} />
                                            <label className="switch-paddle" htmlFor={`s-${cookie.key}`}>
                                                <span className="show-for-sr">{cookie.name}</span>
                                            </label>
                                        </div>
                                        <span className="cookie-name">{cookie.name}</span>
                                    </div>
                                )}
                                <div className="cookie-wrapper" key="necessary">
                                        <div className="switch tiny">
                                            <input className="switch-input" id={`s-necessary`} type="checkbox" checked={true} disabled={true}/>
                                            <label className="switch-paddle" htmlFor={`s-necessary`}>
                                                <span className="show-for-sr">{translate("coptikk.cookie.necessary")}</span>
                                            </label>
                                        </div>
                                        <span className="cookie-name">{translate("coptikk.cookie.necessary")}</span>
                                </div>                                
                            </div>
                        </div>
                        <div className="cookie-banner__buttons">
                        <button type="button" className="button accept-btn" onClick={() => acceptCookies(true)}>
                                {translate("coptikk.cookie.acceptall")}
                            </button>
                            <button type="button" className="button secondary" onClick={() => acceptCookies(false)}>
                                {translate("coptikk.cookie.acceptselection")}
                            </button>
                            <button type="button" className="button secondary" onClick={() => declineCookies()}>
                                {translate("coptikk.cookie.onlynecessary")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="cookie-banner__toggle">
            <div className="row">
                <div className="columns small-12">
                    <div className='cookie-banner__toggle-button' onClick={() => setCollapsed(!collapsed)}>{translate("coptikk.cookie.consent")}</div>
                </div>
            </div>
        </div>
    </div>
}

export default CookieBanner;